// extracted by mini-css-extract-plugin
module.exports = {"root":"bh_b9"};